import Big from 'Common/utils/customBig';

const adaptClientRequestData = data => ({
	...data,
	name: data.name?.trim(),
	wht: data.wht ? Number(Big(data.wht).div(100).toString()) : data.wht,
});

export default adaptClientRequestData;
